// extracted by mini-css-extract-plugin
export default {"iconBack":"button_iconBack__FW4Yl"};